import script from "./Top.vue?vue&type=script&setup=true&lang=ts"
export * from "./Top.vue?vue&type=script&setup=true&lang=ts"

import "./Top.vue?vue&type=style&index=0&id=11507687&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11507687"]])

export default __exports__